import React from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { IAuthContext } from '../../context/auth/auth-context';
import withAuthContext from '../../context/auth/AuthConsumer';
import {
  DataTable,
  DataTableCell,
  DataTableHeadCell,
  DataTableHeadRow,
  DataTableRow,
  DataTableShell,
} from '../ui';

const HeaderLabel = styled.div`
  font-size: 17px;
  font-weight: 600;
`;

const BackWrap = styled.div`
  margin-bottom: 14px;
`;

interface IContactListContainerProps {
  rows: any;
  hideContactListTable: any;
}

const ContactListContainer: React.FC<IContactListContainerProps & { context: IAuthContext }> = (props) => {
  const { rows, hideContactListTable } = props;

  return (
    <>
      <BackWrap>
        <Button
          variant="outline-light"
          onClick={hideContactListTable}
          style={{
            borderColor: 'rgba(52, 211, 153, 0.45)',
            color: '#5eead4',
            fontWeight: 600,
          }}
        >
          ← Back to results
        </Button>
      </BackWrap>
      <DataTableShell>
        <DataTable aria-label="Contacts detail table">
          <thead>
            <DataTableHeadRow>
              <DataTableHeadCell align="center"><HeaderLabel>Contact</HeaderLabel></DataTableHeadCell>
              <DataTableHeadCell align="center"><HeaderLabel>Title</HeaderLabel></DataTableHeadCell>
              <DataTableHeadCell align="center"><HeaderLabel>Phone</HeaderLabel></DataTableHeadCell>
              <DataTableHeadCell align="center"><HeaderLabel>Email</HeaderLabel></DataTableHeadCell>
              <DataTableHeadCell align="center"><HeaderLabel>Address</HeaderLabel></DataTableHeadCell>
            </DataTableHeadRow>
          </thead>
          <tbody>
            {rows.data &&
              rows.data.length > 0 &&
              rows.data.map((row: any, index: number) => (
                <DataTableRow key={row.Name + index} striped index={index}>
                  <DataTableCell style={{ textAlign: 'center' }}>{row.Name}</DataTableCell>
                  <DataTableCell>{row.Title && row.Title.length ? row.Title.join(',') : 'N/A'}</DataTableCell>
                  <DataTableCell>{row.Phone && row.Phone.length ? row.Phone.join(',') : 'N/A'}</DataTableCell>
                  <DataTableCell>{row.Email && row.Email.length ? row.Email.join(',') : 'N/A'}</DataTableCell>
                  <DataTableCell>{row.Address && row.Address.length ? row.Address.join(',') : 'N/A'}</DataTableCell>
                </DataTableRow>
              ))}
          </tbody>
        </DataTable>
      </DataTableShell>
    </>
  );
};

export default withAuthContext(ContactListContainer);
